// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"162":"8478d5629633b82afcd4","821":"f1950e970eefe9c7ba96"}[chunkId] + ".chunk.js";
};